// extracted by mini-css-extract-plugin
module.exports = {"maxValueCell":"max-value-cell-d3d","minValueCell":"min-value-cell-769","percentCell":"percent-cell-84a"};